export const LANGUAGE_LOCALE_FILE = {
  'zh-CN': 'zh_CN',
  'en-US': 'en_US',
  'en-GB': 'en_US',
  'fr-FR': 'fr_FR',
  'ja-JP': 'ja_JP',
};
